// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetCaseResponseModel {
    static getAttributeTypeMap() {
        return GetCaseResponseModel.attributeTypeMap;
    }
}
GetCaseResponseModel.discriminator = undefined;
GetCaseResponseModel.additionalProperties = false;
GetCaseResponseModel.attributeTypeMap = [
    {
        "name": "accountData",
        "baseName": "accountData",
        "type": "AccountModel"
    },
    {
        "name": "caseData",
        "baseName": "caseData",
        "type": "CaseModel"
    },
    {
        "name": "patientData",
        "baseName": "patientData",
        "type": "PatientModel"
    },
    {
        "name": "diagnosisData",
        "baseName": "diagnosisData",
        "type": ""
    },
    {
        "name": "payorData",
        "baseName": "payorData",
        "type": ""
    },
    {
        "name": "pharmacyData",
        "baseName": "pharmacyData",
        "type": ""
    },
    {
        "name": "prescriberData",
        "baseName": "prescriberData",
        "type": ""
    },
    {
        "name": "prescriptionData",
        "baseName": "prescriptionData",
        "type": ""
    },
    {
        "name": "siteData",
        "baseName": "siteData",
        "type": ""
    },
    {
        "name": "surveyData",
        "baseName": "surveyData",
        "type": ""
    },
    {
        "name": "ssn",
        "baseName": "ssn",
        "type": "string"
    },
];
//# sourceMappingURL=getCaseResponseModel.js.map